import { render, staticRenderFns } from "./Categoria.vue?vue&type=template&id=71b1e8b9"
import script from "./Categoria.vue?vue&type=script&lang=ts"
export * from "./Categoria.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports